import { AfterViewInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Currency } from '../../../../@models/erp/compilationData';

@Component({
  selector: 'ngx-doc-form-texfield',
  templateUrl: './doc-form-texfield.component.html',
  styleUrls: ['./doc-form-texfield.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocFormTexfieldComponent implements OnInit, AfterViewInit {

  @Input() title: string;
  @Input() value: string | number;
  @Input() placeholder: string;
  @Input() mode: string;
  @Input() editable: boolean = true;
  @Input() disabled: boolean = false;
  @Input() focused: boolean = false;
  @Input() currency: string = Currency.getDefault().code;
  @Input() format: string = '1.2-2';
  @Input() styles = null;
  @Input() maxlength: number;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() focus: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyupChange: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('textfield') textfield: ElementRef;

  last: number = 0;

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  modelChange(/* event */) {
  }

  ngAfterViewInit(): void {
    if (this.textfield) {
      if (this.focused) {
        this.textfield.nativeElement.focus();
      } else {
        this.textfield.nativeElement.blur();
      }
    }
  }

  updateValue(event) {
    if (this.mode) {
      const val = event.target.value;
      if (this.mode.match(/(currency|float)/)) {
        if (val.match(/[^\s\d,-]/)
                    || (val.match(/-/) && val.lastIndexOf('-') !== 0)
                    || (val.match(/,/g) || []).length > 1) {
          event.target.value = this.last.toString().replace(/\./, ',');
        } else {
          this.last = val;
        }
      } else if (this.mode.match(/integer/)) {
        // console.log('integer', this.last, val);
        if (val.match(/^\s*-?\d*\s*$/)) {
          this.last = val;
        } else {
          event.target.value = this.last;
        }
      }
    }
  }

  onKeyUp(event) {
    if (event.keyCode === 13) { // return
      event.target.blur();
    }
    const ret = (/integer/.test(this.mode) ? +this.textfield.nativeElement.value : this.textfield.nativeElement.value);
    this.keyupChange.emit(ret);
  }

  onBlur(event) {
    let num = event.target.value;
    if (this.mode?.match(/integer/) && num.match(/^\s*-?\s*$/)) {
      // console.log('num', num, this.value)
      num = 0;
      this.value = "0";
      // console.log('post num', num, this.value)
    } else if (this.mode?.match(/(currency|integer|float)/)) {
      num = this.convertToNumber(event.target.value);
      this.value = '-1'; // dummy to trigger currency pipe
      this.cdRef.detectChanges();
      this.value = num;
      this.cdRef.detectChanges();
    }
    this.valueChange.emit(num);
  }

  onFocus(event) {
    if (this.mode && this.mode.match(/(currency|integer|float)/)) {
      const num = this.convertToNumber(event.target.value);
      this.last = num;
      event.target.value = num.toString().replace(/\./, ',');
    }
    const ret = (/integer/.test(this.mode) ? +event.target.value : event.target.value);
    // console.log('emit focus', ret);
    this.focus.emit(ret);
  }

  // TODO: support other currencies
  convertToNumber(val) {
    let num = val.replace(/[\s€\.]/g, '');
    if (num.indexOf(',') > 0) {
      num = num.replace(/,/, '.');
    }
    return +num;
  }

}
